import React from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import Button from "elevate-ui/Button";
import Save from "elevate-ui-icons/Save";
import Clear from "elevate-ui-icons/Clear";
import Map from "elevate-ui-icons/Map";
import GridOn from "elevate-ui-icons/GridOn";
import { Formik, Form } from "formik";

import SortOrderForm from "../listing-search/SortOrderForm";

type $Props = {
  classes: Object,
  className?: Object,
  query: Object,
  sortNameOptions: Array<{ label: string, value: string }>,
  style?: Object,
  handleSearch: Function,
  handleSaveToggle: Function,
  handleClear: Function,
  sortName: string,
  title: string,
  isMapEnabled: boolean,
};

const ListingGridFilters = ({
  classes,
  className,
  handleSearch,
  handleSaveToggle,
  handleClear,
  query,
  sortNameOptions,
  style,
  isMapEnabled,
  sortName,
  title,
}: $Props) => {
  return (
    <div className={classNames(classes.root, className)} style={style}>
      <div className={classes.topLeft}>
        <div>
          <Button
            type="button"
            color="#ff3300"
            icon={<Clear />}
            isOutlined
            onClick={() => handleClear(null, {})}
          >
            Clear
          </Button>
        </div>
        <div>
          <Button
            type="button"
            color="secondary"
            icon={<Save />}
            onClick={handleSaveToggle}
          >
            Save
          </Button>
        </div>
        {!sortName ? (
          <div>
            <SortOrderForm
              items={sortNameOptions}
              query={query}
              handleSearch={handleSearch}
              className={classes.sortOrderForm}
            />
          </div>
        ) : null}
      </div>
      <div>
        {!isMapEnabled && title !== "Featured Homes" ? (
          <Formik
            onSubmit={() => {
              // $FlowIgnore
              document.forms["goToMap"].submit();
            }}
            render={() => (
              <Form
                id="goToMap"
                name="goToMap"
                noValidate
                action="/map"
                method="GET"
              >
                {query &&
                  Object.keys(query).map((queryKey, i) => {
                    if (queryKey === "offset") {
                      return null; // don't include offset from QS
                    }
                    // if the query key is an array, not string
                    if (Array.isArray(query[queryKey])) {
                      return query[queryKey].map((value, i) => {
                        return (
                          <input
                            key={queryKey + i}
                            type="hidden"
                            name={queryKey}
                            value={value}
                          />
                        );
                      });
                    }

                    return (
                      <input
                        key={queryKey + i}
                        type="hidden"
                        name={queryKey}
                        value={query[queryKey]}
                      />
                    );
                  })}
                <Button type="submit" icon={<Map />}>
                  Map
                </Button>
              </Form>
            )}
          />
        ) : title !== "Featured Homes" ? (
          <Formik
            onSubmit={() => {
              // $FlowIgnore
              document.forms["goToPhotoCards"].submit();
            }}
            render={() => (
              <Form
                id="goToPhotoCards"
                name="goToPhotoCards"
                noValidate
                action="/listings"
                method="GET"
              >
                {query &&
                  Object.keys(query).map((queryKey, i) => {
                    if (queryKey === "offset") {
                      return null; // don't include offset from QS
                    }

                    // if the query key is an array, not string
                    if (Array.isArray(query[queryKey])) {
                      return query[queryKey].map((value, i) => {
                        return (
                          <input
                            key={queryKey + i}
                            type="hidden"
                            name={queryKey}
                            value={value}
                          />
                        );
                      });
                    }

                    return (
                      <input
                        key={queryKey + i}
                        type="hidden"
                        name={queryKey}
                        value={query[queryKey]}
                      />
                    );
                  })}
                <Button type="submit" icon={<GridOn />}>
                  Grid
                </Button>
              </Form>
            )}
          />
        ) : null}
      </div>
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    position: "relative",
    width: "100%",
    maxWidth: "1172px",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "24px auto 0",
    padding: "0 24px",
    zIndex: theme.zIndex["listingGridFilters"],
    [theme.breakpoints(1173)]: {
      padding: 0,
    },
  },
  topLeft: {
    display: "flex",
    position: "relative",
    flexFlow: "row wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: 0,
    "& > div": {
      paddingRight: theme.spacing.unit * 0.5,
      marginBottom: theme.spacing.unit * 0.75,
    },
    [theme.breakpoints(611)]: {
      "& > div": {
        marginBottom: "0",
      },
    },
  },
});

export default withStyles(styles)(ListingGridFilters);
